import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

export interface DeleteDialogFunctionality {
  onDelete: () => Promise<void>;
  deleteWarningMessage?: string;
  onClose: () => void;
  openDialog: () => void;
  isDialogOpen: boolean;
}

interface DeleteDialogProps extends DeleteDialogFunctionality {
  disabled: boolean;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  isDialogOpen,
  onClose,
  onDelete,
  disabled,
  deleteWarningMessage,
}) => {
  return (
    <Dialog open={isDialogOpen} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">Delete</DialogTitle>
      <DialogContent sx={{ minWidth: 400 }}>
        {deleteWarningMessage && (
          <DialogContentText>{deleteWarningMessage}</DialogContentText>
        )}
        <DialogContentText>
          The data will be permanently deleted and cannot be recovered.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="light" disabled={disabled}>
          Cancel
        </Button>
        <Button
          onClick={async () => {
            await onDelete();
          }}
          color="error"
          variant="contained"
          disabled={disabled}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
